export const ER_USER_MANUAL_OPERATOR_PDF_URL =
  'https://asabuenafrutawus.blob.core.windows.net/public/BuenaFrutaSolutions_UserManual_Operator.pdf'
